import { Routes } from '@angular/router';
import { SessionRoutes } from '@core';
import { SessionActiveComponent } from './components/session-active/session-active.component';
import { SessionAddDrillComponent } from './components/session-add-drill/session-add-drill.component';
import { SessionDrillCompletedComponent } from './components/session-drill-completed/session-drill-completed.component';
import { SessionQuickSetupComponent } from './components/session-quick-setup/session-quick-setup.component';
import { SessionSummaryComponent } from './components/session-summary/session-summary.component';

export const SessionRouting: Routes = [
  { path: `${SessionRoutes.QUICK_SETUP}/:drillId`, component: SessionQuickSetupComponent },
  { path: SessionRoutes.ACTIVE, component: SessionActiveComponent },
  { path: SessionRoutes.DRILL_COMPLETED, component: SessionDrillCompletedComponent },
  { path: SessionRoutes.ADD_DRILL, component: SessionAddDrillComponent },
  { path: `${SessionRoutes.SUMMARY}/:id`, component: SessionSummaryComponent },
  { path: '', redirectTo: SessionRoutes.ACTIVE, pathMatch: 'full' }
];
